import React, {Component, useEffect, useState} from "react";
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import Receive from "./receive/Receive";
import Associate from "./associate/Associate";
import LineHaulDetail from "./linehaul/LineHaulDetail";
import Induct from "./induct/Induct";
import Package from "./package/Package";
import {publishCountToCSM} from "./util/Util";
import {DEFAULT_ROUTES} from "./util/RouteConstants";
import {DARK_MODE} from "./util/Constants";
import InductManagementV2 from "./inductmanagementv2/InductManagementV2";
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import Technician from "./technician/Technician";
import blueDarkTokens from "@amzn/meridian-tokens/theme/blue-dark";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";
import Theme from "@amzn/meridian/theme";
import {
  getDarkModeStatus,
  setDarkModeStateListener,
} from "./handler/ParentDataHandler";

function publishRoutePath(location) {
    const metricProcessName = "SCC_INDUCT";
    const metricName = location.pathname;
    publishCountToCSM({
        processName: metricProcessName,
        metricName: metricName
    });
}

const AppComponent = () => {
    const [currentDarkMode, setCurrentDarkMode] = useState(DARK_MODE.LIGHT);
  
    useEffect(() => {
      setDarkModeStateListener(setCurrentDarkMode);
      getDarkModeStatus();
    }, []);
  
    return (
      <Theme
        tokens={currentDarkMode === DARK_MODE.DARK ? blueDarkTokens : blueLightTokens}
      >
        <Switch>
            {Object.keys(DEFAULT_ROUTES).map((path, index) => {
                return <Route exact path={path} key={index}>
                    <Redirect to={DEFAULT_ROUTES[path]}/>
                </Route>
            })}
            <Route path="/receive" component={Receive} />
            <Route path="/associate" component={Associate} />
            <Route path="/linehaulDetail/:lineHaulId/:origin/:arrivalTime/:departTime" component={LineHaulDetail} />
            <Route path="/induct" component={Induct} />
            <Route path="/aslInduct" component={Technician} />
            <Route path="/inductManagement" component={InductManagementV2}/>
            <Route exact path="/packageList/:lineHaulId" component={Package} />
            <Route exact path="/packageList/:lineHaulId/:containerId/:packageState/:filter/:path" component={Package} />
            <Route exact path="/packageList/:lineHaulId/:filterType/:filterValue" component={Package} />
        </Switch>
       
      </Theme>
    );
  };
  

class App extends Component {

    componentWillMount() {
        publishRoutePath(this.props.location);
        this.onRouteSwitch = this.props.history.listen(() => {
            publishRoutePath(this.props.location);
        });
    }
    componentWillUnmount() {
        this.onRouteSwitch();
    }

    render() {
        return <AppComponent />;
    }
}


export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/app.js